import React from 'react';
import './price.scss';

const Price: React.FC<{
    price: number;
    color?: 'dark'|'gray'|'light-gray'|'white'|'red'|'green';
    weight?: '400'|'500'|'600'|'700';
    size?: 'xs'|'sm'|'md'|'lg'|'xl';
    inline?: boolean;
    crossed?: boolean;
    className?: string;
}> = ({
    price,
    color = 'dark',
    weight = '500',
    size = 'md',
    inline,
    crossed,
    className
}) => {
    const [priceInteger, priceFractional]: string[] = parseFloat(String(price)).toFixed(2).split('.');

    return (
        <span className={`${className || ''} price price-${color} price--fw-${weight} price--fs-${size} ${crossed ? 'price-crossed' : ''}`}>
            {priceInteger.replace(/\B(?=(?:\d{3})+(?!\d))/g, ' ')}
            ,
            {inline
                ? priceFractional
                : (
                    <sup>
                        {priceFractional}
                    </sup>
                )}
            <sub>
                zł
            </sub>
        </span>
    );
};

export default Price;
